import React, { Component } from 'react'
import { Icon } from 'antd'
import AppDialog from 'components/AppDialog'
import { ParamGroupEdit } from './ParamGroupEdit'
import { ParamEdit } from './ParamEdit'
import AppIconAction from 'components/AppAction/AppIconAction'

interface MenuProps {
	isShow?: boolean
	menu?: any
	item?: any[]
	show?: () => void
	afterSave: () => void
	scope?: any
	application?: any
}

export default class ParamGroupItem extends Component<MenuProps> {
	state = {
		isShow: false,
	}

	show = () => {
		this.setState((preState: any) => {
			return {
				isShow: !preState.isShow,
			}
		})
	}
	editParam = (data: any) => {
		AppDialog.open(<ParamEdit scope={this.props.scope} customerData={data} afterSave={this.props.afterSave} />, {
			title: '修改参数',
			height: 500,
			width: 660,
		})
	}
	editParamGroup = (data: any) => {
		AppDialog.open(<ParamGroupEdit mode={1} customerData={data} afterSave={this.props.afterSave} />, {
			title: '修改分组',
			size: 'small',
		})
	}
	addParam = (data: any) => {
		AppDialog.open(
			<ParamEdit
				scope={this.props.scope}
				application={this.props.application}
				groupId={data.id}
				afterSave={this.props.afterSave}
			/>,
			{
				title: '新增参数',
				height: 500,
				width: 660,
			}
		)
	}

	render() {
		return (
			<div className="NavItem">
				<ul>
					<li>
						<Icon type={this.state.isShow ? 'caret-up' : 'caret-down'} onClick={this.show}></Icon>
						<div className="tree-action">
							<span>
								<AppIconAction
									actionCode="90202501"
									type="plus"
									title="新增参数"
									action={() => {
										this.addParam(this.props.menu)
									}}
								/>
								<AppIconAction
									actionCode="90202502"
									type="edit"
									title="修改分组"
									action={() => {
										this.editParamGroup(this.props.menu)
									}}
								/>
								<AppIconAction actionCode="90202503" type="delete" title="删除分组" />
							</span>
						</div>
						<span onClick={this.show}>{this.props.menu.showName}</span>
						<ul className={this.state.isShow ? '' : 'hidden'}>
							{this.props.item.map((v, k) => {
								return (
									<li key={k}>
										<div className="tree-action">
											<AppIconAction
												actionCode="90202502"
												type="edit"
												title="修改参数项"
												action={() => this.editParam(v)}
											/>
											<AppIconAction actionCode="90202503" type="delete" title="删除参数项" />
										</div>
										<span>{v.showName}</span>
									</li>
								)
							})}
						</ul>
					</li>
				</ul>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/modeling/param/components/ParamGroupItem.tsx